import { Route, Routes } from '@angular/router';
import { AppLayoutData } from '@spotter/components/layout/app-layout/app-layout.component';
import { LoggedInGuard } from '@spotter/guards/login-guard';
import { setupRoutes } from '@spotter/providers/spotter-providers';


const appLayoutData: AppLayoutData = {
    site: 'viewer',
    sidebarLayout: {
        sections: [
            {
                title: "Explore", accessRights: 'public', translate: false,
                items: [
                    { id: 'map', routerLink: '/map', title: "Map", icon: 'map', translate: false },
                    { id: 'grid', routerLink: '/grid', title: "Grid", icon: 'table-cells-large', translate: false },
                    { id: 'upload', routerLink: '/upload', title: "Upload", icon: 'upload', translate: false },
                    { id: 'download', routerLink: '/download', title: "Download", icon: 'download', translate: false },
                ]
            }
        ]
    }
}

const appRoutes: Routes = [
    { path: '', loadComponent: () => import('./pages/map/map.page').then(m => m.MapPage) },
    { path: 'submit', loadComponent: () => import('./pages/submit/submit.page').then(m => m.SubmitPage) },
];



export const routes: Routes = setupRoutes(appRoutes, appLayoutData, undefined, () => import('./app-layout.component').then(m => m.ViewerLayoutComponent));